import { chainInfos, DEFAULT_CHAIN_ID } from '@ui/constants/chain';
import { getContractAddress } from '@ui/services/contract/constants';
import { ChainId } from '@ui/types/chain';
import { defineChain } from 'viem';

const createChainConfig = <CID extends ChainId>(
  chainId: CID,
  override: {
    blockExplorers: {
      default: {
        name: string;
      };
    };
    nativeToken: {
      name: string;
      decimals: number;
    };
  },
) => {
  const multicall3 = getContractAddress('MultiCall3', chainId);

  return defineChain({
    id: chainId,
    name: chainInfos[chainId].label,
    nativeCurrency: {
      ...override.nativeToken,
      symbol: chainInfos[chainId].nativeCurrency,
    },
    rpcUrls: {
      default: {
        webSocket: [...chainInfos[chainId].wsUrls],
        http: [...chainInfos[chainId].rpcUrls],
      },
    },
    blockExplorers: {
      default: {
        ...override.blockExplorers.default,
        url: chainInfos[chainId].explorer,
      },
    },
    contracts: {
      multicall3: multicall3
        ? {
            address: multicall3,
          }
        : undefined,
    },
    testnet: chainInfos[chainId].isTestnet,
  });
};

export const monadTestnet = createChainConfig(ChainId.MONAD_TESTNET, {
  blockExplorers: {
    default: {
      name: 'Mon Testnet Explorer',
    },
  },
  nativeToken: {
    decimals: 18,
    name: 'MON',
  },
});

export const monadMainnet = createChainConfig(ChainId.MONAD_MAINNET, {
  blockExplorers: {
    default: {
      name: 'Monad Explorer',
    },
  },
  nativeToken: {
    decimals: 18,
    name: 'MON',
  },
});

/**
 * adding a condition to put the default chain as the 1st item in this array
 * coz wagmi will always return the 1st chain in first render or `useChain` and other related hooks
 * which can cause
 * - unnecessary render
 * - excessive query key (react-query)
 * ..
 */
export const chains =
  DEFAULT_CHAIN_ID === ChainId.MONAD_MAINNET
    ? ([monadMainnet, monadTestnet] as const)
    : ([monadTestnet, monadMainnet] as const);
